import React from 'react';
import { Link } from 'react-router-dom';

export const BrandCard = ({ brand, categorySlug }) => {
  // If categorySlug is provided, link to /category/:categorySlug/brand/:brandSlug
  // Otherwise, just show the brand name without a link or use a default category
  const brandUrl = categorySlug 
    ? `/category/${categorySlug}/brand/${brand.slug}`
    : null;

  const content = (
    <div className="flex items-center justify-center h-20">
      {brand.logo ? (
        <img
          src={brand.logo}
          alt={brand.name}
          className="max-h-full max-w-full object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
        />
      ) : (
        <span className="text-lg font-medium text-[#0B1F3B] group-hover:text-[#D4AF37] transition-colors">
          {brand.name}
        </span>
      )}
    </div>
  );

  if (brandUrl) {
    return (
      <Link
        to={brandUrl}
        className="group block p-6 bg-white border border-gray-100 hover:border-[#D4AF37]/30 transition-all duration-300"
        data-testid={`brand-card-${brand.slug}`}
      >
        {content}
      </Link>
    );
  }

  return (
    <div
      className="group block p-6 bg-white border border-gray-100"
      data-testid={`brand-card-${brand.slug}`}
    >
      {content}
    </div>
  );
};

export default BrandCard;
